import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuid from '../../../helpers/uuid';
import {
  onStart as onStartAction,
  onMove as onMoveAction,
  onEnd as onEndAction,
} from '../modules';

// tests for react components do not currently exist
// istanbul ignore next
class DragSwipeContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.id = props.id || uuid();
  }

  render() {
    const { childComponent: ChildComponent, dragSwipe = {} } = this.props;
    return <ChildComponent id={this.id} {...this.props} {...dragSwipe[this.id]} />;
  }
}

// tests for react components do not currently exist
// istanbul ignore next
const mapStateToProps = ({ dragSwipe }) => ({
  dragSwipe,
});

// tests for react components do not currently exist
// istanbul ignore next
const mapDispatchToProps = dispatch => ({
  onStartAction: props => dispatch(onStartAction(props)),
  onMoveAction: props => dispatch(onMoveAction(props)),
  onEndAction: props => dispatch(onEndAction(props)),
});

DragSwipeContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
  dragSwipe: PropTypes.objectOf(PropTypes.any),
};

export default connect(mapStateToProps, mapDispatchToProps)(DragSwipeContainer);
